var _excluded = ["columns", "gutterSpace", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import space from "../../../utils/space";
var columnBasicStyles = function columnBasicStyles(numberOfColumns) {
  return css(["grid-template-columns:repeat(", ",1fr);"], numberOfColumns);
};
var columnStyles = function columnStyles(numberOfColumns) {
  if (numberOfColumns.small) {
    var numberOfColumnsBreakpoint = numberOfColumns;
    return css(["", " ", "{", "}", "{", "}"], columnBasicStyles(numberOfColumnsBreakpoint.small), breakpoint("medium"), columnBasicStyles(numberOfColumnsBreakpoint.medium), breakpoint("large"), columnBasicStyles(numberOfColumnsBreakpoint.large));
  }
  return css(["", ""], columnBasicStyles(numberOfColumns));
};
var gutterBasicStyles = function gutterBasicStyles(gutterSpace) {
  if (gutterSpace.x) {
    return css(["grid-column-gap:", ";grid-row-gap:", ";"], space(gutterSpace.x), space(gutterSpace.y));
  }
  return css(["grid-gap:", ";"], space(gutterSpace));
};
var gutterStyles = function gutterStyles(gutterSpace) {
  if (gutterSpace.small) {
    return css(["", ";", "{", ";}", "{", ";}"], gutterBasicStyles(gutterSpace.small), breakpoint("medium"), gutterBasicStyles(gutterSpace.medium), breakpoint("large"), gutterBasicStyles(gutterSpace.large));
  }
  return css(["", ";"], gutterBasicStyles(gutterSpace));
};
var StyledAdvancedProductTilesOrg = styled.div.withConfig({
  componentId: "sc-ltbhqc-0"
})(function (_ref) {
  var $columns = _ref.$columns,
    $gutterSpace = _ref.$gutterSpace;
  return css(["", " ", ";display:grid;"], columnStyles($columns), gutterStyles($gutterSpace));
});
function AdvancedProductTilesOrg(_ref2) {
  var columns = _ref2.columns,
    gutterSpace = _ref2.gutterSpace,
    children = _ref2.children,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledAdvancedProductTilesOrg, _extends({
    $columns: columns,
    $gutterSpace: gutterSpace
  }, restProps), children);
}
export default AdvancedProductTilesOrg;